<template>
  <div class="preview-resource page">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }"
        >练习中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>
        <span @click="goBack" class="go-back"
          >个性化练习</span
        ></el-breadcrumb-item
      >
      <el-breadcrumb-item>查看题目资源</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="r-header">
      <card-header class="mt-20">查看题目资源</card-header>
      <button><span @click="goBack">继续布置</span></button>
    </div>
    <div class="hr"></div>
    <section class="r-content">
      <div class="subtitle">
        <card-header class="mt-20">按知识点查看</card-header>
        <span class="t-remark">
          （个性化练习推送的题目来自以下
          {{ atKnowledgeList.length }}
          个知识点的题目资源库，实际推送题目内容根据学生的答题情况动态调整，每个学生题量一致，题目有所区别）
        </span>
      </div>
      <div class="knowledge-name">
        <p
          v-for="(name, index) in atKnowledgeList"
          :key="index"
          @click="onItemClick(name)"
          :class="[name.isClicked ? 'is-active' : '']"
        >
          {{ name.tag_name }}
        </p>
      </div>
    </section>
    <section class="r-question-list">
      <p class="r-question-list__title">
        <span>*</span>共{{ questionList.length }}题
      </p>
      <question-content
        :questionList="this.questionList"
        fromPage="FromResource"
      />
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getQuestionByCodes } from '@/api/pt';
import CardHeader from '@/components/card-header.vue';
import QuestionContent from './components/question-content.vue';

export default {
  name: 'PreviewResource',
  components: {
    CardHeader,
    QuestionContent,
  },
  data() {
    return {
      currentKnowledgeCode: '',
      questionList: [],
      knowledgeList: [],
    };
  },
  computed: {
    ...mapGetters([
      'atKnowledgeList',
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onItemClick(item) {
      this.atKnowledgeList.forEach((pItem) => {
        this.$set(pItem, 'isClicked', false);
        if (pItem.tag_code === item.tag_code) {
          this.$set(item, 'isClicked', true);
        }
      });
      this.currentKnowledgeCode = item.tag_code;
      this.getQuestionByCodes();
    },
    // 根据知识点获取试题
    getQuestionByCodes() {
      this.questionList = [];
      getQuestionByCodes({ tag_codes: this.currentKnowledgeCode }).then((res) => {
        if (res.code === 200) {
          const questionArr = res.data.list;
          this.questionList = Object.values(questionArr);
          this.questionList.forEach((item) => {
            this.$set(item, 'active', false);
          });
        }
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'CreateAt') {
      this.$set(to.meta, 'isUseCache', true);
    }
    next();
  },
  created() {
    this.atKnowledgeList.forEach((pItem, pIndex) => {
      // 默认选中第一个
      this.$set(pItem, 'isClicked', false);
      if (pIndex === 0) {
        this.$set(pItem, 'isClicked', true);
        this.currentKnowledgeCode = pItem.tag_code;
      }
    });
    this.getQuestionByCodes();
  },
};
</script>
<style lang="scss" scoped>
header {
  height: 100px;
  // background: url("../images/en.png") no-repeat 530px center;
  // background-size: 462px 130px;
}
.go-back {
  font-weight: 700;
  text-decoration: none;
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  color: #303133;
  &:hover {
    color: #1989fa;
    cursor: pointer;
  }
}
.r-header {
  height: 100px;
  display: flex;
  padding: 0 16px;
  justify-content: space-between;
  align-items: baseline;
  background: url("../images/en.png") no-repeat right center;
  background-size: 462px 130px;
  button {
    display: inline-block;
    width: 140px;
    height: 40px;
    background: #1989fa;
    box-shadow: 0px 2px 4px 0px rgba(104, 154, 179, 0.5);
    border-radius: 4px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    span {
      height: 40px;
      line-height: 37px;
      display: inline-block;
      background: url("../images/write.png") no-repeat left center;
      background-size: 26px 28px;
      padding-left: 30px;
    }
  }
}
.r-content {
  padding: 15px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  .subtitle {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    .t-remark {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fb2121;
    }
  }
  .knowledge-name {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    padding: 5px 12px 13px 0;
    margin-top: 16px;
    min-height: 60px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    p {
      color: #1989fa;
      background: #ffffff;
      margin-left: 12px;
      margin-top: 8px;
      min-width: 105px;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      border-radius: 3px;
      border: 1px solid;
      padding: 6px 3px;
      text-align: center;
      &.is-active {
        background: #1890ff;
        color: #ffffff;
      }
    }
  }
}
.r-question-list {
  padding: 20px 15px;
  &__title {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    span {
      color: #f56c6c;
      padding-right: 6px;
    }
  }
}
</style>
